/* tslint:disable */
/* eslint-disable */
export enum HostingEnvironment {
  Production = 1,
  Preview = 2,
  Test = 3,
  Development = 4
}
